import React from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import {
  DislikeTwoTone,
} from '@ant-design/icons';

export type CheckButtonProps = ButtonProps & {
  onlyIcon?: boolean;
};

const RefuseButtonAction = ({
  children = 'Refuse',
  onlyIcon = false,
  ...otherProps
}: CheckButtonProps) => {
  return (
    <Button icon={<DislikeTwoTone twoToneColor="red" />} style={{ height: 40,width:100 }} {...otherProps}>
      {!onlyIcon ? children : null}
    </Button>
  );
};

export default RefuseButtonAction;

